import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { PeSelectComponent, PeSelectOption } from '../pe-select/pe-select.component';
import { getCountryOptions } from '../../utils/country.util';

@Component({
  selector: 'app-country-select',
  standalone: true,
  imports: [CommonModule, FormsModule, PeSelectComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true
    }
  ],
  template: `
    <app-pe-select
      [options]="options"
      [placeholder]="placeholder"
      [searchable]="true"
      [disabled]="disabled"
      [ngModel]="value"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onModelChange($event)">
    </app-pe-select>
  `
})
export class CountrySelectComponent implements ControlValueAccessor, OnInit {
  @Input() placeholder = 'Select country';
  @Input() inputClass = '';
  @Input() disabled = false;

  options: PeSelectOption[] = [];
  value = '';

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit(): void {
    this.options = getCountryOptions().map(c => ({ value: c.code, label: c.name }));
  }

  onModelChange(newValue: string): void {
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
  }

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
